import { useQuery } from '@tanstack/react-query';
import { INDEXER_URL } from '../config/env.ts';

/** GET from the indexer; disabled (data undefined, `configured` false) when no indexer URL is set. */
export function useIndexer<T>(path: string | null, refetchMs = 30_000) {
  const q = useQuery({
    queryKey: ['indexer', path],
    enabled: Boolean(INDEXER_URL && path),
    refetchInterval: refetchMs,
    queryFn: async () => {
      const res = await fetch(`${INDEXER_URL}${path}`);
      if (!res.ok) throw new Error(`indexer ${res.status}`);
      return (await res.json()) as T;
    },
  });
  return { ...q, configured: Boolean(INDEXER_URL) };
}
